// @flow

import { createContext, useContext } from 'react';
import { type PaymentMethod } from './payment-method';

type PaymentMethods = ImmutableArray<PaymentMethod>;

const PaymentMethodsContext = createContext<?PaymentMethods>(null);

export const PaymentMethodsProvider = PaymentMethodsContext.Provider;

export function usePaymentMethods(): PaymentMethods {
  const context = useContext(PaymentMethodsContext);
  if (!context) {
    throw new Error('Payment methods not provided');
  }
  return context;
}
